import { SET_ACCOUNTS, GET_ACCOUNTS_BY_CAPABILITY_SUCCESS, UPDATE_ACCOUNTS } from './actions';
import { formatAccounts } from '../../utils/formatUtils';

const reducer = (state = [], action) => {
	switch (action.type) {
		case SET_ACCOUNTS:
			return [...action.accounts];
		case GET_ACCOUNTS_BY_CAPABILITY_SUCCESS: {
			const {
				payload: { accounts },
			} = action;
			const updatedAccounts = accounts.filter(
				(account) => !state.some((stateAccount) => stateAccount.id === account.id)
			);
			return [...state, ...formatAccounts(updatedAccounts)];
		}
		case UPDATE_ACCOUNTS: {
			return [...state, ...formatAccounts(action.accounts)];
		}
		default:
			return state;
	}
};
export default reducer;
